export { default } from "./footer";
export * from "./footer";
